export const toArray = (object: any): any[] => Object.values(object);
